// extracted by mini-css-extract-plugin
module.exports = {"Container":"ErrorGridItem_Container__A0uLO"};